import * as Yup from 'yup';

export default Yup.object().shape({
    name: Yup.string().required('Заполните поле'),
    mail: Yup.string().when('gift', {
        is: true,
        then: fieldSchema => fieldSchema.email('Неверный формат email')
            .required( 'Заполните поле' )}),
    mailConfirmation: Yup.string()
        .when('mail', {
            is: val => val && val.length > 0,
            then: () => Yup.string()
                .oneOf([Yup.ref("mail")], "Email должны совпадать")
                .required('Обязательное поле')
        }),
    customerName: Yup.string().when('customerFound', {
        is: false,
        then: fieldSchema => fieldSchema.required('Заполните поле')}),
    customerSurname: Yup.string().when('customerFound', {
        is: false,
        then: fieldSchema => fieldSchema
            .required('Заполните поле')}),
    customerEmail: Yup.string().when('customerFound', {
        is: false,
        then: fieldSchema => fieldSchema.email('Неверный формат email')
            .required( 'Заполните поле' )}),
    customerEmailConfirmation: Yup.string().when("customerEmail", {
        is: val => val && val.length > 0,
        then: () => Yup.string()
            .oneOf([Yup.ref("customerEmail")], "Email должны совпадать")
            .required('Обязательное поле')
    }),
    acceptConditions: Yup.boolean()
        .required('Нужно согласие на обработку персональных данных')
        .oneOf([true], 'Нужно согласие на обработку персональных данных')
});
